import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';


interface TryagainPromptProps {
  open: boolean;
  errorMessage: string;
  onClose: () => void;
  onTryAgain: () => void;
}

const TryagainModal: React.FC<TryagainPromptProps> = ({ open, errorMessage, onClose, onTryAgain }) => {
  const dialogStyle: React.CSSProperties = {
    position: 'absolute',
    top: '0%', // Adjust as needed
    left: '50%',
    transform: 'translateX(-50%)',
    textAlign: 'center',
  };


  const tryAgainButtonStyle: React.CSSProperties = {
    // margin: 'auto',
    marginTop: '16px',
  };

  return (
    <Dialog open={open} fullWidth={true} maxWidth={'sm'} sx={{
        '& .MuiDialog-paper':{
            position:"absolute" ,
            top:"-4%"
        }
        }} onClose={onClose}>
      <DialogTitle>Error</DialogTitle>
      <DialogContent>
        <p>{errorMessage}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onTryAgain} color="primary" variant="contained" style={tryAgainButtonStyle}>
          Try Again
        </Button>
        <Button onClick={onClose} color="primary" variant="outlined" style={tryAgainButtonStyle}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TryagainModal;
